module.exports = __webpack_public_path__ + "assets/img/case5.80f78e25.png";